module.exports = __webpack_public_path__ + "static/media/top_banner_11.60388d2d.png";